export default {
  welcome: 'Velkommen til Ducky',
  terms: `MARKDOWN:
Hvis du ble invitert hit av en organisasjon, involverer de deg i en ambisiøs kampanje for å lære om bærekraft og for å hjelpe organisasjonen til å endre seg.

Ducky vil benytte fremtidig overskudd til verktøy som gjør det mulig å beregne miljøpåvirkningen og samarbeide med venner og kolleger om kraftig handling.

Hvis du fortsetter, samtykker du til at Ducky lagrer ditt navn og epost, og lagrer og bearbeider opplysninger om deg og dine vaner. Din organisasjon (arbeidsplass, skole e.l.) vil ikke få tilgang til dine personopplysninger, men vil få tilgang til data fra kampanjen i anonymisert form. Formålet for datainnsamlingen er forskning og planlegging av bærekraftstiltak i organisasjonen.

Hvis arrangøren selv deltar i konkurransen, vil de kunne se dine personlige besparelser og aktiviteter som du har registrert i web-appen, slik som andre medlemmer på ditt lag kan. 

[Se hele personvernerklæringen her](https://www.ducky.eco/no-no/support/personvernerkl%C3%A6ring)`,
};
